// app-handshake.service.ts
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, firstValueFrom, Observable } from 'rxjs';
import { ConstantsService } from './constants.service';
import { BaseService } from './base.service';

@Injectable({ providedIn: 'root' })
export class AppHandshakeService extends BaseService{

  private done = false;
  private pending: Promise<boolean> | null = null;

  constructor(public override http: HttpClient, 
    public override constants: ConstantsService) {
      super(http, constants,'/api/handshake');
    }

  ensureHandshake(): Promise<boolean> {
    if(this.done) return Promise.resolve(true);
    if(this.pending) return this.pending;

    this.pending = firstValueFrom(
      this.http.get(this.constants.api_handshake, {responseType: 'text'}))
    .then(() => {
      this.done = true;
      return true;
    })
    .catch(() => {
      this.done = true;
      return true;
    });  

    return this.pending;
  }
}
